<template lang="pug">
  .padding-container.view-documents.relative
    paginate(:click-handler="GET_DATA" container-class="paginate" prev-text="&#171;" next-text="&#187;" :page-count="pages")
    p(v-if="loading")
      loading(:active.sync="loading" :is-full-page="false")
    table
      tr
        Th(name="id")
        Th.fixed-size(name="name")
        Th(name="publish_date")
        Th(name="requires_premium")
        Th(name="type")
        Th(name="file")
        Th(name="created_at")
      tr(v-for="d in data")
        Td(:value="d.id" :id="d.id" :link="model")
        Td(:value="d.name" :id="d.id" :link="model")
        Td(:value="d.publish_date" :id="d.id" :link="model")
        Td(:value="d.requires_premium" tag="boolean" :id="d.id" :link="model")
        Td(:value="d.type" :id="d.id" :link="model")
        Td(:value="d.file_name" :id="d.id" :external="linker(d.file_name)")
        Td(:value="d.created_at" :id="d.id" :link="model")

      Button(to="/documents/create-document" :text="$t('interface.create')")
    Notice(v-if="error") {{ error }}

</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import DocumentService from '@/services/document'
  import Notice from '@/components/Notice'

  import Th from '@/components/table/Th'
  import Td from '@/components/table/Td'

  export default {
    components: { 
      Loading, Notice, Th, Td
    },
    data: function() {
      return {
        api: process.env.VUE_APP_HOST || 'http://localhost:3333',
        model: 'documents',
        service: DocumentService,
        pages: 1,
        perPage: 15,
        totalRows: 1,
        data: [],
        loading: true,
        error: ''
      }
    },
    methods: {
      linker: function(string) {
        if(string)
          return this.api + '/uploads/documents/' + string;
        return '#';
      },
      async GET_DATA(page) {
        const meta = this.$route.meta;

        let pageObject = {};
        pageObject.page = page;

        let filter = '';
        let val = '';

        if(meta.filter) {
          pageObject.filter = meta.filter.name
          pageObject.value = meta.filter.value
        }

        try {
          this.loading = true;
          const response = await this.crudGetPage(pageObject, DocumentService)

          if(response)
            return true;

        } catch(err) {
          this.loading = false;
        }
      }
    },
    created() {
      this.$on('loading', function (e) {
        this.loading = e;
      });
      this.$on('error', function (e) {
        this.error = e;
      });
      this.$on('success', function (e) {
        console.log(e);
        this.data = e.data;
        this.totalRows = e.totalRows;
        this.pages = Math.ceil(e.totalRows / this.perPage)
        this.loading = false;
        this.error = '';
      });
      this.GET_DATA(1);
    },
    watch: {
      '$route' (to, from) {
        // we changing page? better reload
        if(to.name != from.name) {
          console.log(to)
          this.GET_DATA(1);
        }
      }
    }
  }
</script>

<style lang="scss">
  table {
    .colour-box {
      color:#eee;
      padding: 8px;
      text-align:center;
      box-shadow: 0 7px 6px -5px #101010;
    }
  }
</style>